module.exports = __webpack_public_path__ + "static/pteranodon_halfling-d6eab98d6a4e0a1ff84905daadc6ac3d.png";